import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './MonthNavItem.module.scss';

const MonthNavItem = ({ isDisabled, data, dateMoment, onClick, isActive }) => {
  const onSelectNewMonth = () => {
    onClick(dateMoment);
  };

  return (
    <button
      disabled={isDisabled}
      onClick={onSelectNewMonth}
      type='button'
      className={cx(styles.wrapper, 'btn p-0 mx-1', {
        [styles.active]: isActive,
      })}
    >
      <div className={cx('d-flex align-items-center justify-content-center px-2')}>
        <i className={cx(styles.icon, 'icon-bullet-point', data.status ? styles[data.status] : '')} />
        <span className={styles.date}>{dateMoment.format('MMM YYYY')}</span>
      </div>
    </button>
  );
};

MonthNavItem.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default React.memo(MonthNavItem);
